import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { FilterItem } from '@app/shared/components/api/models/filterItem.model';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-search-bar',
  imports: [
    CommonModule,
    IconField,
    InputIcon,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    Select,
    ButtonModule,
    DatePickerModule
  ],
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: true,
})
export class SearchBarComponent implements OnInit, AfterViewInit, OnChanges {
  searchForm: FormGroup;

  @Input() showPrimaryBtn = true;
  @Output() onPrimaryBtnClick = new EventEmitter<void>();
  @Input() primaryBtnLabel = 'Ação';
  @Input() primaryBtnIcon?: string;

  @Input() showSecondBtn = false;
  @Output() onSecondBtnClick = new EventEmitter<void>();
  @Input() secondBtnLabel = 'Second Action';
  @Input() secondBtnIcon?: string;

  @Input() showFilterBtn = false;
  @Output() onFilterBtnClick = new EventEmitter<void>();
  @Input() filterBtnLabel = 'Filtros';
  @Input() filterBtnIcon = 'pi pi-filter';

  @Input() showFilterIcon = false;
  @Output() onfilterIconClick = new EventEmitter<void>();
  @Input() filterIconDisplay?: string;

  @Output() formValueChange = new EventEmitter<any>();

  @Input() filters: FilterItem[] = [];
  @Input() sortFields: any[] = [];

  constructor() {
    this.searchForm = new FormGroup({
      sortField: new FormControl(''),
    });
  }

  ngOnInit() {
    // Certifique-se de que o campo 'id' está presente no sortFields
    const idField = { label: 'Data de criação', value: 'id' };
    if (!this.sortFields.some((field) => field.value === 'id')) {
      this.sortFields.unshift(idField);
    }

    this.initializeForm();
    this.setupValueChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.['filters']) {
      this.initializeForm();
      this.setupValueChanges();
    }
  }

  setupValueChanges() {
    this.filters.forEach((filter) => {
      const control = this.searchForm.get(filter.controlName);

      if (filter.type === 'text') {
        control?.valueChanges.subscribe((value) => {
          if (value.length >= 3 && value.length % 3 === 0)
            this.formValueChange.emit({
              ...this.searchForm.value,
              [filter.controlName]: value,
            });

          if (value.length === 0)
            this.formValueChange.emit({
              ...this.searchForm.value,
              [filter.controlName]: value,
            });
        });
      } else if (filter.type === 'dropdown') {
        control?.valueChanges.subscribe((value) => {
          const formValue = { ...this.searchForm.value };

          if (value !== null && value !== undefined && value !== '') {
            formValue[filter.controlName] = value;
          } else {
            formValue[filter.controlName] = '';
            delete formValue[filter.controlName];
          }

          for (const key in formValue) {
            if (formValue[key] === null || formValue[key] === undefined) {
              formValue[key] = '';
            }
          }

          this.formValueChange.emit(formValue);
        });
      }
    });

    this.searchForm.get('sortField')?.valueChanges.subscribe(() => {
      // this.emitSortValue();
    });
  }

  emitSortValue() {
    const sortField = this.searchForm.get('sortField')?.value;

    if (sortField) {
      this.formValueChange.emit({
        ...this.searchForm.value,
        OrderBy: `${sortField} desc`,
      });
    }
  }

  ngAfterViewInit() {
    this.filters.forEach((filter) => {
      if (filter.type === 'text') {
        const inputElement = document.getElementById(
          filter.controlName
        ) as HTMLInputElement;
        if (inputElement) {
          inputElement.addEventListener('paste', (event: ClipboardEvent) => {
            const pasteData = event.clipboardData?.getData('text');
            if (pasteData && pasteData.length >= 3) {
              setTimeout(() => {
                this.formValueChange.emit(this.searchForm.value);
              }, 0);
            }
          });
        }
      }
    });
  }

  initializeForm() {
    this.filters.forEach((filter) => {
      if (!this.searchForm.contains(filter.controlName)) {
        this.searchForm.addControl(filter.controlName, new FormControl(''));
      }
    });
  }

  primaryBtnClick() {
    this.onPrimaryBtnClick.emit();
  }

  secondBtnClick() {
    this.onSecondBtnClick.emit();
  }

  filterBtnClick() {
    this.onFilterBtnClick.emit();
  }

  filterIconClick() {
    this.onfilterIconClick.emit();
  }
}
